import React from 'react';

import * as S from './styles';

interface Props {
    header: string;
    index?: number;
}

export const QuestionHeader: React.SFC<Props> = ({ header, index }) => (
    <S.QuestionHeader>{index ? `${index}. ${header}` : header}</S.QuestionHeader>
);
